import { gql } from '@apollo/client';

import { SHARE_FIELDS } from './fragments';

export const sharePlaylistGroup = gql`
  ${SHARE_FIELDS}
  mutation sharePlaylistGroup(
    $groups: [ID]!
    $organizationId: ID!
    $playlistId: ID!
    $notifyNew: Boolean
  ) {
    sharePlaylistGroup(
      groups: $groups
      organizationId: $organizationId
      playlistId: $playlistId
      notifyNew: $notifyNew
    ) {
      created {
        ...ShareFields
      }
      deleted {
        ...ShareFields
      }
    }
  }
`;

export const sharePlaylistOrganization = gql`
  ${SHARE_FIELDS}
  mutation sharePlaylistOrganization(
    $organizationId: ID!
    $playlistId: ID!
    $notifyNew: Boolean
  ) {
    sharePlaylistOrganization(
      organizationId: $organizationId
      playlistId: $playlistId
      notifyNew: $notifyNew
    ) {
      created {
        ...ShareFields
      }
      deleted {
        ...ShareFields
      }
    }
  }
`;

export const sharePlaylistUser = gql`
  ${SHARE_FIELDS}
  mutation sharePlaylistUser(
    $users: [ID]!
    $invitations: [ID]
    $organizationId: ID!
    $playlistId: ID!
    $notifyNew: Boolean
  ) {
    sharePlaylistUser(
      users: $users
      invitations: $invitations
      organizationId: $organizationId
      playlistId: $playlistId
      notifyNew: $notifyNew
    ) {
      created {
        ...ShareFields
      }
      deleted {
        ...ShareFields
      }
    }
  }
`;

export const unsharePlaylist = gql`
  ${SHARE_FIELDS}
  mutation unsharePlaylist($organizationId: ID!, $playlistId: ID!) {
    unsharePlaylist(organizationId: $organizationId, playlistId: $playlistId) {
      created {
        ...ShareFields
      }
      deleted {
        ...ShareFields
      }
    }
  }
`;
